// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"550":"1a4c6f78","860":"d92b9494"}[chunkId] + ".chunk.css";
};